import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import "./UpgradeDialog.scss";

const UpgradeSuccessDialog = (props: any) => {
  const { open, onClose, onContinue, type } = props;

  const handleEmailButtonClick = () => {
    window.location.href = "mailto:support@planetwise.io";
  };

  return (
    <Fragment>
      <div>
        <Dialog className="pw-confirmation-dialog" open={open}>
          <div className="pw-confirmation-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text pw-primary-color">
                Upgrade Successful
              </div>
              <div className="cursor-pointer">
                {/* <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={onClose}
                /> */}
              </div>
            </div>

            <div className="w-full mt-2 pw-color-neutral-900 text-md">
              {type === "plan" ? (
                <span>Congratulations on upgrading your plan!</span>
              ) : (
                <span>Congratulations on purchasing your add-ons!</span>
              )}
              <span>
                &nbsp;Your payment will be deducted automatically, and an
                invoice will be sent to your mail shortly.
                <br />
                <br />
                If you have any questions or concerns, feel free to reach out to
                us at
                <span
                  className="inline-flex text-blue-500 cursor-pointer"
                  onClick={handleEmailButtonClick}
                >
                  support@planetwise.io
                </span>
                . Thank you for choosing our service.
              </span>
            </div>
          </div>
          <div className="flex flex-row justify-end pw-confirmation-dialog-footer w-full gap-6 py-3 mt-4">
            {/* <div
              className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
              onClick={onClose}
            >
              Cancel
            </div> */}
            <button
              className={`pw-bunit-button-primary pw-bunit-button-next text-white font-bold cursor-pointer bg-primary px-4`}
              onClick={onContinue}
            >
              Continue
            </button>
          </div>
        </Dialog>
      </div>
    </Fragment>
  );
};

export default UpgradeSuccessDialog;
